import React, { useContext, useEffect, useState } from 'react';
import { TransitionContext } from '../Context/TransitionContext';

import './Terms.css';

import { useScreenTransition } from '../Hooks/useScreenTransition';
import SignInForm from './SignIn/SignInForm';
import CreateAccount from './CreateAccount/CreateAccount';


import Navbar from './HomePage/header';

import Footer from './HomePage/footer';
import SupportSection from './HomePage/SupportSection';

const Refunds = ({ windowSize }) => {

 
  const { setColor, webP } = useContext(TransitionContext);

  useEffect(() => {
    setColor(false);
  }, [setColor]);

  const [isModalOpen, setIsModalOpen]=useState(false);
  const [isCreateAccountOpen, setIsCreateAccountOpen]=useState(false);


  const handleLoginOpen=(newState)=>{
    setIsModalOpen(newState);
  }

  const handleCreateAccountOpen=(newState)=>{
    setIsCreateAccountOpen(newState);
  }

  const { transitionTo } = useScreenTransition();

  const refunds = [
    {
      title: "Overview",
      content: <>
      Below you'll find the most common reasons for refund requests. Please review this policy to ensure you understand and agree with it before placing your order with us. If you believe your order is eligible for a refund or you have questions about our policy, please <span className="hoveringTextLink" onClick={(e) => transitionTo('/contact',e)}>contact us</span> with all pertinent details so we can review your request.
      </>
    },
    {
      title: "Order Changes",
      content: <>
      You can contact us to request changes to the services you've ordered before the service has been provided. This includes both adding and removing services or the quantity of service. Once the service has begun, we typically cannot make changes, but we will accommodate your request if possible.
      </>
    },
    {
      title: "Cancellations",
      content: <>
        You may request a cancellation anytime before your order is completed. We will prorate the refund for your primary service (translation) based on the amount of work the translator has completed on your project. For example:
        <br/><br/>
        - You have placed an order for three pages of certified translation totaling $74.85 and request to cancel before the project being assigned to a translator. You will receive a full refund of $74.85.<br/><br/>
        - You have placed an order for five pages of certified translation totaling $124.75 and request to cancel while the order is in progress. We contact the translator to stop work and get a current word count. The translator has translated three pages so your prorated refund will be for two pages totaling $49.95.<br/><br/>
        - You have placed an order for 335 words of standard translation totaling $33.50 and request to cancel after the order is complete. You will not receive a refund.<br/><br/>
        Secondary services (notarization, shipping, etc.) not provided will be refunded in full. Secondary services that have been provided are not eligible for a refund.
      </>
    },
    {
      title: "Turnaround Times",
      content: <>
        We provide a turnaround estimate during checkout based on historical order data. This is an estimate of the time it will take from when we assign your project to a translator until they return it translated and you are notified. We only work with human translators so we cannot guarantee a specific turnaround time, only that we'll put best efforts towards meeting or beating the estimate provided.
          <br/><br/>The turnaround time starts once the project is assigned to the translator as there can be delays during the initial processing of the order. For example, if you don't upload a legible source file, select the wrong language pair or choose the wrong number of words/pages you can expect a delay before the estimated turnaround time begins as we'll have to resolve the underlying issue before assigning the project to a translator. If the wrong number of words/pages are selected at checkout, you can also expect the turnaround estimate to change once the count is corrected.
        </>
    },
    {
      title: "Quality Concerns",
      content: <>
        Judging the quality of a translation is subjective as there are often multiple ways to phrase words and word choices will vary based on experience and understanding of the context of the source material. We will make every attempt to work with you to ensure you are satisfied with the final translation, but the translator ultimately has the final determination of word choice.
          <br/><br/>In the rare case that a translator has failed to deliver a translation up to our quality standards and revisions won't be adequate to bring it up to our standards, we may, at our sole discretion, issue a refund or offer a re-translation free of charge.
         </>
    },
    {
      title: "Revision Requests",
      content: <>
      You may request a revision through your order status page within 30 days of the translation has been made available to you. Revisions are free of charge as long the source material is not being edited. Source material changes will be handled on a case-by-case basis. We might be able to edit the existing translation and charge for the additional translated words, but if the changes are substantial a full retranslation might be required.
          <br/><br/>The most common revision requests we see are for the names of people and places. When placing your order, we request this information, and we urge you to provide it as names can be particularly challenging to translate. This will significantly reduce the need for revisions, which ensure you have your finalized translation as quickly as possible.
      </>
    },
    {
      title: "Translation Acceptance",
      content: <>
      Except for USCIS, we do not offer refunds for translation acceptance issues. It is your sole responsibility to ensure we meet the requirements of your receiving party. We strongly suggest you contact us with a list of their requirements before placing your order to ensure we meet them if you have any doubt.
          <br/><br/>We do offer a money-back guarantee for certified translations declined by USCIS for additional peace of mind, though we've never had a translation declined after thousands of submissions as we exceed their translation requirements.
      </>
    },
    {
      title: "Shipping Issues",
      content: <>
      We exclusively ship with the <span className="hoveringTextLink" onClick={() => window.open('https://usps.com', '_blank')}>United States Postal Service (USPS)</span>. If you become aware of an issue with your shipment, please <span className="hoveringTextLink" onClick={(e) => transitionTo('/contact',e)}>contact us</span> immediately so we may assist you as possible to resolve. USPS is a third-party service provider, and we do not offer refunds for issues related to their handling of your shipment.
      </>
    },
  ]

  return (
    <div className='bg-[#EFF3F5] w-full flex flex-col items-center cursor-default'>
    <SignInForm open={isModalOpen} isLoginFormOpen={handleLoginOpen} isCreateAccountOpen={handleCreateAccountOpen}/>
    <CreateAccount open={isCreateAccountOpen} isCreateAccountOpen={handleCreateAccountOpen} isLoginFormOpen={handleLoginOpen}/>


     {/* banner */}
     <div className='w-full md:p-4 p-2'>

      <div className='w-full bg-[#12ABBF] rounded-4xl max-md:rounded-xl max-md:pb-4'>
          {/* navbar */}
        <div className=' pt-[30px] pb-[27px] mx-4'>
            <Navbar windowSize={windowSize} isLoginFormOpen={handleLoginOpen}/>
        </div>
        <div className='bannerContainer px-2'>
            <h1 className='bannerText text-center'>Refund Policy</h1>
        </div>
        <div className='flex flex-col gap-4 w-full items-center pb-[107px] max-md:pb-[30px] px-2'>
          <p className='text-[#fff] text-base text-center xl:w-[50%] md:w-1/2 w-full'>By making a purchase from us you agree to be bound by the following Refund Policy, please read it thoroughly before placing an order.</p>
          <p className='text-[#fff] text-base text-center xl:w-[50%] md:w-1/2 w-full'>Last updated November 14, 2020</p>
        </div>
      </div>

      {refunds.map(refund => <div className="bg-white rounded-4xl overflow-hidden shadow-sm py-12 my-4 max-md:rounded-xl">
        <h2 className='font-secondary font-medium md:text-5xl text-4xl text-tertiary uppercase text-left mb-6 px-8'>{refund.title}</h2>
          <p className="px-8 w-full max-w-[1440px] justify-center mx-auto text-left text-xl">
           {refund.content}
           </p>
      </div>)}
      

      <SupportSection windowSize={windowSize} />

     </div>

    <div className=' w-full pb-10 bg-[#12ABBF]'>
          <Footer windowSize={windowSize} light={true}  />
      </div>  

  </div>
  );
}

export default Refunds;